import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import PropertyCard from "../components/PropertyCard";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { Heart, ShoppingCart } from "lucide-react";

export default function Saved() {
  const { user, openAuth } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!user) {
      openAuth();
      return;
    }
    api.get("/saved").then((r) => setItems(r.data)).catch(() => {});
  }, [user, openAuth]);

  const favorites = items.filter((i) => i.kind === "favorite");
  const cart = items.filter((i) => i.kind === "cart");

  const grid = (list, emptyText, tid) =>
    list.length ? (
      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid={tid}>
        {list.map((i) => <PropertyCard key={i.property.property_id} property={i.property} />)}
      </div>
    ) : (
      <p className="mt-10 text-center text-sm text-muted-foreground">{emptyText}</p>
    );

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8" data-testid="saved-page">
      <h1 className="font-heading text-3xl font-bold tracking-tight">Favorites & Shortlist</h1>
      <p className="mt-1 text-sm text-muted-foreground">Compare shortlisted properties and connect with owners.</p>
      <Tabs defaultValue="favorites" className="mt-6">
        <TabsList>
          <TabsTrigger value="favorites" data-testid="saved-tab-favorites" className="gap-2"><Heart className="h-4 w-4" /> Favorites ({favorites.length})</TabsTrigger>
          <TabsTrigger value="cart" data-testid="saved-tab-cart" className="gap-2"><ShoppingCart className="h-4 w-4" /> Cart ({cart.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="favorites">{grid(favorites, "No favorites yet. Tap the heart on any property.", "favorites-grid")}</TabsContent>
        <TabsContent value="cart">{grid(cart, "Your shortlist cart is empty.", "cart-grid")}</TabsContent>
      </Tabs>
    </div>
  );
}
